module.exports = __webpack_public_path__ + "img/signout.2330a60c.svg";